import { render } from "./UpdatePasswordForm.vue?vue&type=template&id=61889ef4"
import script from "./UpdatePasswordForm.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordForm.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "61889ef4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61889ef4', script)) {
    api.reload('61889ef4', script)
  }
  
  module.hot.accept("./UpdatePasswordForm.vue?vue&type=template&id=61889ef4", () => {
    api.rerender('61889ef4', render)
  })

}

script.__file = "resources/js/Pages/Profile/Partials/UpdatePasswordForm.vue"

export default script